import React, {useState, useEffect, useContext} from 'react';
import Preloader from '../../components/Preloader/Preloader';
import { Offcanvas, Table } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';
import OffcanvasTemplate from '../search/OffcanvasTemplate';
import axios from 'axios';
import { books_category, bookClassification } from '../../ProData';
import AutoComplete from '../../components/AutoComplete';
import { useSnackbar } from 'notistack';
import BookCategoryCarosel from '../BookCategoryCarosel';
import {Helmet} from 'react-helmet-async';
import { fetchAuthSession } from 'aws-amplify/auth';
import BarcodePrint from './BarcodePrint';
import Barcode from 'react-barcode';
import {useReactToPrint} from "react-to-print";

const config = require('../../config.json');

export default function BarcodeMainView() {

    // --- End Modernized & Business Logic Functions ---
  // Modern UI styles for BarcodeMainView
  const barcodeModernStyles = `
    .barcode-main-section {
      background: linear-gradient(135deg, #f0f4fa 0%, #e0e7ef 100%);
      min-height: 100vh;
      padding: 32px 0 40px 0;
      font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .barcode-card {
      background: #fff;
      border-radius: 18px;
      box-shadow: 0 6px 24px 0 rgba(44, 62, 80, 0.13);
      padding: 2.2rem 1.5rem 1.5rem 1.5rem;
      margin-bottom: 2.5rem;
      max-width: 1100px;
      width: 100%;
      transition: box-shadow 0.2s;
    }
    .barcode-card:hover {
      box-shadow: 0 10px 32px 0 rgba(44, 62, 80, 0.18);
    }
    .barcode-title {
      font-size: 2.2rem;
      font-weight: 800;
      color: #1a2a4f;
      margin-bottom: 0.7rem;
      letter-spacing: 0.5px;
      text-align: center;
      text-shadow: 0 2px 8px rgba(44,62,80,0.07);
    }
    .barcode-search-form {
      background: #f8fbff;
      border-radius: 16px;
      box-shadow: 0 2px 12px rgba(44, 62, 80, 0.09);
      padding: 1.5rem 1.2rem 1.2rem 1.2rem;
      margin-bottom: 2rem;
    }
    .barcode-search-form select,
    .barcode-search-form input {
      border-radius: 10px !important;
      font-size: 1.08rem;
      padding: 10px 14px;
      border: 1.5px solid #d0e2ff;
      margin-bottom: 0.5rem;
      background: #fafdff;
      box-shadow: 0 1px 4px rgba(44,62,80,0.04);
      transition: border 0.2s, box-shadow 0.2s;
    }
    .barcode-search-form select:focus,
    .barcode-search-form input:focus {
      border: 1.5px solid #4f8cff;
      outline: none;
      box-shadow: 0 2px 8px rgba(44,62,80,0.09);
    }
    .barcode-search-form .btn-box {
      margin-top: 0;
      padding: 10px 22px;
      font-size: 1.08rem;
      border-radius: 10px;
      background: linear-gradient(90deg, #4f8cff 0%, #6ed0fa 100%);
      color: #fff;
      border: none;
      font-weight: 700;
      letter-spacing: 0.5px;
      box-shadow: 0 2px 8px rgba(44,62,80,0.09);
      transition: background 0.2s, box-shadow 0.2s, transform 0.2s;
    }
    .barcode-search-form .btn-box:hover, .barcode-search-form .btn-box:focus {
      background: linear-gradient(90deg, #063547 60%, #7ee8fa 100%);
      color: #fff;
      transform: translateY(-2px) scale(1.04);
      box-shadow: 0 6px 24px 0 rgba(44, 62, 80, 0.13);
    }
    .barcode-table {
      border-radius: 18px;
      overflow: hidden;
      box-shadow: 0 6px 24px rgba(44, 62, 80, 0.13);
      background: #fff;
      margin-bottom: 0;
      font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
      border-collapse: separate;
      border-spacing: 0;
    }
    .barcode-table th, .barcode-table td {
      vertical-align: middle !important;
      text-align: center;
      word-break: break-word;
      padding: 0.75rem 0.5rem;
      border-bottom: 1.5px solid #e3eafc;
      background: #fff;
      transition: background 0.2s, box-shadow 0.2s;
    }
    .barcode-table th {
      font-size: 0.97rem;
      background: linear-gradient(90deg, #eaf3ff 60%, #fafdff 100%) !important;
      color: #1a2a4f;
      font-weight: 900;
      position: sticky;
      top: 0;
      z-index: 2;
      box-shadow: 0 2px 8px rgba(44, 62, 80, 0.06);
      letter-spacing: 0.7px;
      text-transform: uppercase;
      border-top: none;
      white-space: nowrap;
    }
    .barcode-table td {
      font-size: 0.98rem;
    }
    .barcode-table tbody tr {
      transition: background 0.2s, box-shadow 0.2s;
      border-radius: 12px;
      box-shadow: none;
    }
    .barcode-table tbody tr:hover {
      background: #eaf6ff !important;
      box-shadow: 0 4px 16px rgba(44,62,80,0.10);
      transform: scale(1.01);
    }
    .barcode-table tbody tr:nth-child(even) {
      background: #fafdff !important;
    }
    .barcode-table td {
      border-right: 1px solid #f0f4fa;
    }
    .barcode-table td:last-child {
      border-right: none;
    }
    .barcode-table .fa-print {
      color: #4f8cff;
      font-size: 1.5em;
      cursor: pointer;
      transition: color 0.2s, background 0.2s, transform 0.2s, box-shadow 0.2s;
      padding: 7px 12px;
      border-radius: 8px;
      background: #f0f4fa;
      border: 1px solid #e3eafc;
      margin: 0 2px;
      box-shadow: 0 2px 4px rgba(44,62,80,0.04);
    }
    .barcode-table .fa-print:hover {
      color: #fff;
      background: linear-gradient(90deg, #4f8cff 60%, #6ed0fa 100%);
      transform: scale(1.12);
      box-shadow: 0 4px 16px rgba(44,62,80,0.13);
      border: 1.5px solid #4f8cff;
    }
    .barcode-table td {
      font-weight: 500;
      color: #2a3659;
    }
    .barcode-table td:first-child {
      font-weight: 700;
      color: #4f8cff;
      background: #fafdff;
      border-left: none;
      border-radius: 10px 0 0 10px;
    }
    .barcode-table td:last-child {
      border-radius: 0 10px 10px 0;
    }
    .barcode-container.barcode-display {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0.2rem 0;
    }
    .barcode-label {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 0.2rem 0;
    }
    .barcode-label p {
      margin: 0;
      font-size: 1.15rem;
      font-weight: 700;
      color: #1a2a4f;
      text-align: center;
      width: 100%;
      letter-spacing: 0.2px;
      line-height: 1.3;
    }
    @media (max-width: 900px) {
      .barcode-title {
        font-size: 1.15rem;
      }
      .barcode-card {
        padding: 0.8rem 0.2rem 0.5rem 0.2rem;
      }
      .barcode-table th, .barcode-table td {
        font-size: 0.93rem;
        padding: 0.4rem 0.15rem;
      }
    }
    @media (max-width: 600px) {
      .barcode-main-section {
        padding: 2px 0 6px 0;
      }
      .barcode-title {
        font-size: 0.98rem;
        margin-bottom: 0.5rem;
      }
      .barcode-card {
        border-radius: 8px;
        padding: 0.4rem 0.05rem 0.3rem 0.05rem;
        box-shadow: 0 2px 8px rgba(44,62,80,0.08);
      }
      .barcode-search-form {
        border-radius: 8px;
        padding: 0.3rem 0.05rem 0.2rem 0.05rem;
      }
      .barcode-search-form select,
      .barcode-search-form input {
        font-size: 0.91rem;
        padding: 5px 5px;
      }
      .barcode-table th, .barcode-table td {
        font-size: 0.87rem;
        padding: 0.2rem 0.05rem;
      }
      .barcode-table th {
        font-size: 0.85rem;
      }
      .barcode-label p {
        font-size: 0.95rem;
      }
    }
    @media (max-width: 480px) {
      .barcode-card {
        padding: 0.2rem 0 0.1rem 0;
      }
      .barcode-search-form {
        padding: 0.1rem 0 0.1rem 0;
      }
      .barcode-table th, .barcode-table td {
        font-size: 0.8rem;
        padding: 0.1rem 0.01rem;
      }
      .barcode-label p {
        font-size: 0.85rem;
      }
    }
    /* Responsive table scroll */
    .barcode-table-responsive {
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      margin-bottom: 1rem;
    }
  `;

      const { validateLogin, loggedUser } = useContext(ProductContext);
    const { enqueueSnackbar } = useSnackbar();

    const [searchResult, setSearchResult]=useState([]);
    const [searchCounter, setSearchCounter] = useState(0);
    const [searchValue, setSearchValue]= useState('');
    const [searchTopic, setSearchTopic]=useState('AccessionNo');
    const [show, setShow] = useState(false);
    const [loaded, setLoaded] = useState(true);
    const [selectedBook, setSelectedBook] = useState({Accession_No:"", Book_Author:"",bookCategory:"NA",
      Book_Classification_No: "", bookEdition: "NA", bookPages: "", bookPrice: "0", Publishing_Year: "",
      Book_Publisher:"", Book_Scope:"", Book_Status:"", Book_Title:"", registeredOn:"", autoGenerate:false,
      authorMark:'',bookAbstract:'',bookKeywords:'',bookCopies:'',bookPublisherLocation:'',bookSubTitle:'',
      bookDimension:'',isbn:''});
    const [barcodeView,setBarcodeView] = useState(true);
    const [dispMsg, setDispMsg] = useState('');
    const [searchCompleted, setSearchCompleted] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [userType, setUserType] = useState('');
    const componentRef = React.useRef(null);
    const currentPrintRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [sorting, setSorting]=useState({field:"CallNo",order:"asc"});

    // Reset sorting when a new search is performed
    useEffect(() => {
      if (typeof searchCounter === 'undefined') return;
      setSorting({ field: 'CallNo', order: 'asc' });
    }, [searchCounter]);

    const reactPrint = useReactToPrint({
      contentRef: componentRef,
      documentTitle: "AwesomeFileName",
    });


const handleBarCodePrint = () => {
  reactSinglePrint(); // triggers print
};

const reactSinglePrint = useReactToPrint({
  contentRef: currentPrintRef,
  documentTitle: 'Barcode',
});

    const handleClose = () => setShow(false);
    const handleShow = (event, item) => {
      event.preventDefault();
      setSelectedBook(item);
      setShow(true);
    }
  
    useEffect(()=>{
      if(!loggedUser.isAuthenticated){
        validateLogin();
      }else{
        const temp=books_category.filter((item)=>item.categoryDisplay==="Yes");
        setCategoryList(temp);
      }
    },[loggedUser])
  
    const handleSearch=async(event)=>{
        event.preventDefault();
        try{
            //console.log("search value :", searchValue);
            //console.log("search topic :", searchTopic);
            if(searchValue.length===0){
              enqueueSnackbar('Search Value cannot be empty',{variant:'info'}); 
            }else{
              setLoaded(false);
              setDispMsg('');
              setSearchCompleted(false);
              setSearchResult([]);  
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const clientID="AKLibrary";
            var keysearchValue="";
            if(searchTopic==="BookCategory"){
              keysearchValue=searchValue;
            }else{
              keysearchValue=searchValue.toUpperCase();
            }
            await axios.get(`${config.api.invokeUrl}/search/books?fetchKey=${keysearchValue}&fetchOption=${searchTopic}&clientID=${clientID}`, {
            headers: {
              Authorization: idToken,
             'x-api-key':config.api.key
            }
          }).then(async(response) => {
            //console.log("response : ", response.data);
            setDispMsg(response.data.length+' - Books Found');
            const sortedResults = (response.data || []).slice().sort((a, b) => {
              const aAuthor = (a.Book_Author || a.bookAuthor || '')?.toString();
              const bAuthor = (b.Book_Author || b.bookAuthor || '')?.toString();
              const authorCmp = aAuthor.localeCompare(bAuthor, undefined, {numeric: true, sensitivity: 'base'});
              if (authorCmp !== 0) return authorCmp;
              const aTitle = (a.Book_Title || a.bookTitle || '')?.toString();
              const bTitle = (b.Book_Title || b.bookTitle || '')?.toString();
              const titleCmp = aTitle.localeCompare(bTitle, undefined, {numeric: true, sensitivity: 'base'});
              if (titleCmp !== 0) return titleCmp;
              const aAcc = (a.Accession_No || a.accessionNo || '')?.toString();
              const bAcc = (b.Accession_No || b.accessionNo || '')?.toString();
              return aAcc.localeCompare(bAcc, undefined, {numeric: true, sensitivity: 'base'});
            });
            setSearchResult(sortedResults);
            setSearchCounter(c => c + 1);
            enqueueSnackbar(response.data.length+' - Books Found',{variant:'success'});
            setLoaded(true);
            setSearchCompleted(true);
        }).catch((error)=>{
          console.log("error:", error);
          setLoaded(true);
          enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
      })}
        }catch(error){
            //console.log("error1:", error);
            setLoaded(true);
            enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        }
    }

    const handleSortKey = async (event, value, order) => {
      const fieldMap = {
        AccessionNo: 'Accession_No',
        BookTitle: 'Book_Title',
        BookAuthor: 'Book_Author',
        CallNo: 'Book_Classification_No',
        IssuedTo: 'bookedfor',
      };
      const key = fieldMap[value];
      if (!key) return;
      const arr = (searchResult || []).slice();
      const sorted = arr.slice().sort((a, b) => {
        const va = (a[key] || a[key.toLowerCase()] || '')?.toString();
        const vb = (b[key] || b[key.toLowerCase()] || '')?.toString();
        const cmp = va.localeCompare(vb, undefined, {numeric: true, sensitivity: 'base'});
        return order === 'asc' ? cmp : -cmp;
      });
      setSearchResult(sorted);
      setSorting({ field: value, order });
    }

    const reactPrintAll=(event)=>{
      event.preventDefault();
      reactPrint();
    }

    const processSelection=(ivalue)=>{
      //console.log("ivalue:", ivalue);
      if(ivalue){
      if(searchTopic==="BookCategory"){
        setSearchValue(ivalue.svalue);
      }else if(searchTopic==="BookClassification"){
        setSearchValue(ivalue.value);
      }else{
        setSearchValue(ivalue.name);
      }
    }else{
      setSearchValue(userType);
    }
    }

  return (
    <div className="">
      <style>{barcodeModernStyles}</style>
      <Helmet>
        <title>Barcode Print - Inigo Library - Arul Kadal - Chennai</title>
        <meta name="description" content="BarCode - Inigo Library - Arul Kadal - Chennai" />
        <meta name="keywords" content="BarCode - Inigo Library - Arul Kadal - Chennai" />
      </Helmet>

      <Offcanvas show={show} onHide={handleClose} placement={["end"]} scroll={true}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title><i className="fa fa-id-card" aria-hidden="true"></i> {"  -   "}{selectedBook.accessionNo}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <OffcanvasTemplate selectedBook={selectedBook} />
        </Offcanvas.Body>
      </Offcanvas>
      {!loaded && <Preloader show={loaded ? false : true} />}

      <section className="">
        <div className="container">
          <div className="barcode-card">
            <div className="barcode-title">Barcode Printing</div>
            <form className="barcode-search-form">
              <div className="row g-1 align-items-center justify-content-center">
                <div className="col-12 col-md-3 d-flex align-items-center mb-2 mb-md-0" style={{height: '48px'}}>
                  <select name="searchOption" id="bookSearch"
                    className="form-select w-100 h-100"
                    style={{minHeight: '44px', height: '100%'}}
                    value={searchTopic}
                    onChange={event=>setSearchTopic(event.target.value)}>
                    <option value="AccessionNo">Book ID</option>
                    <option value="Call No">Call No</option>
                    <option value="BookTitle">Book Title</option>
                    <option value="BookAuthor">Author</option>
                <option value="BookClassification">Classification</option>
                  </select>
                </div>
                {searchTopic==="BookCategory" ? (
                  <div className="col-12 col-md-5 d-flex align-items-center mb-2 mb-md-0" style={{height: '48px'}}>
                    <AutoComplete
                      data={categoryList}
                      onSelect={country => processSelection(country)}
                      style={{width: '100%', height: '100%'}}
                    />
                  </div>
                ) :searchTopic==="BookClassification" ? (
              <div className="col-12 col-md-6 d-flex align-items-center mb-2 mb-md-0" style={{height: '48px'}}>
                <select
                  className="form-select w-100 h-100"
                  style={{minHeight: '44px', height: '100%'}}
                  value={searchValue}
                  onChange={e => setSearchValue(e.target.value)}>
                  <option value="">Select Classification</option>
                  {bookClassification && bookClassification.map((bc, idx) => (
                    <option key={idx} value={(bc && (bc.value || bc.svalue || bc.name)) || bc}>
                      {(bc && (bc.svalue || bc.label || bc.name || bc.value)) || bc}
                    </option>
                  ))}
                </select>
              </div>
            ): (
                  <div className="col-12 col-md-5 d-flex align-items-center mb-2 mb-md-0" style={{height: '48px'}}>
                    <input type="text" className="form-control w-100 h-100" style={{minHeight: '44px', height: '100%'}} placeholder="" onChange={event=>setSearchValue(event.target.value)}/>
                  </div>
                )}
                <div className="col-12 col-md-2 d-flex align-items-center mb-2 mb-md-0" style={{height: '48px'}}>
                  <button className='btn-box w-100 h-100' style={{minHeight: '44px', height: '100%'}} onClick={event=>handleSearch(event)}>
                    <i className="fa fa-search" aria-hidden="true"></i> Search
                  </button>
                </div>
                <div className="col-12 col-md-2 d-flex align-items-center mb-2 mb-md-0" style={{height: '48px'}}>
                  <button className='btn-box w-100 h-100' style={{minHeight: '44px', height: '100%'}} onClick={event=>reactPrintAll(event)}>
                    <i className="fa fa-print" aria-hidden="true"></i> Print All
                  </button>
                </div>
              </div>
            </form>
            {searchCompleted && (
              <div className="row mt-3">
                <div className="col-md-6 ">
                  <h4>{dispMsg}</h4>
                </div>
              </div>
            )}
            <div className="mt-1">
              <div style={{display: "none"}}>
                {barcodeView ? <BarcodePrint searchResult={searchResult} componentRef={componentRef} reactPrint={reactPrint}/> : null}
              </div>
              <div className='col-12 barcode-table-responsive'>
                {searchResult.length > 0 ? (
                  <Table hover className="barcode-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>
                          <span>Accession No</span>
                          <button type="button" className="sort-btn ms-1" title="Sort by Accession No"
                            onClick={event => handleSortKey(event, "AccessionNo", sorting.field === "AccessionNo" && sorting.order === "asc" ? "desc" : "asc")}
                            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', verticalAlign: 'middle' }}>
                            <i className={
                              sorting.field === "AccessionNo"
                                && sorting.order === "asc"
                                  ? "fa fa-arrow-up text-primary"
                                  : "fa fa-arrow-down text-primary"
                            }
                            style={{ fontSize: '1.1em', opacity: sorting.field === "AccessionNo" ? 1 : 0.7 }}></i>
                          </button>
                        </th>
                        <th>
                          <span>Book Title</span>
                          <button type="button" className="sort-btn ms-1" title="Sort by Book Title"
                            onClick={event => handleSortKey(event, "BookTitle", sorting.field === "BookTitle" && sorting.order === "asc" ? "desc" : "asc")}
                            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', verticalAlign: 'middle' }}>
                            <i className={
                              sorting.field === "BookTitle"
                                && sorting.order === "asc"
                                  ? "fa fa-arrow-up text-primary"
                                  : "fa fa-arrow-down text-primary"
                            }
                            style={{ fontSize: '1.1em', opacity: sorting.field === "BookTitle" ? 1 : 0.7 }}></i>
                          </button>
                        </th>
                        <th>
                          <span>Author</span>
                          <button type="button" className="sort-btn ms-1" title="Sort by Author"
                            onClick={event => handleSortKey(event, "BookAuthor", sorting.field === "BookAuthor" && sorting.order === "asc" ? "desc" : "asc")}
                            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', verticalAlign: 'middle' }}>
                            <i className={
                              sorting.field === "BookAuthor"
                                && sorting.order === "asc"
                                  ? "fa fa-arrow-up text-primary"
                                  : "fa fa-arrow-down text-primary"
                            }
                            style={{ fontSize: '1.1em', opacity: sorting.field === "BookAuthor" ? 1 : 0.7 }}></i>
                          </button>
                        </th>
                        <th>
                          <span>Call No</span>
                          <button type="button" className="sort-btn ms-1" title="Sort by Call No"
                            onClick={event => handleSortKey(event, "CallNo", sorting.field === "CallNo" && sorting.order === "asc" ? "desc" : "asc")}
                            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', verticalAlign: 'middle' }}>
                            <i className={
                              sorting.field === "CallNo"
                                && sorting.order === "asc"
                                  ? "fa fa-arrow-up text-primary"
                                  : "fa fa-arrow-down text-primary"
                            }
                            style={{ fontSize: '1.1em', opacity: sorting.field === "CallNo" ? 1 : 0.7 }}></i>
                          </button>
                        </th>
                        <th>Status</th>
                        <th>BarCode</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchResult.map((item, index) => (
                        <tr key={index}>
                          <td onClick={event => handleShow(event, item)} style={{ cursor: 'pointer', color: '#4f8cff', fontWeight: 600 }}>{index + 1}</td>
                          <td>{item.Accession_No}</td>
                          <td>{item.Book_Title}</td>
                          <td>{item.Book_Author}</td>
                          <td>{item.Book_Classification_No}</td>
                          <td>{item.Book_Status}</td>
                          <td>
                           <div  ref={el => {
                            if (index === selectedIndex) currentPrintRef.current = el;
                          }} >
                              <div className=" barcode-display barcode-row"> {/*remoned barcode-container className*/}
                               
                                <div className="barcode-label">
                                  <span style={{ textAlign: 'center', width: '100%', fontWeight: '900', color: '#000' }}>{item.Book_Classification_No}{" "}{item.authorMark}</span>
                  
                                    <Barcode
                                      width={2.5}
                                      height={36}
                                      margin={0}
                                      fontSize={18}
                                      value={item.Accession_No}
                                    />
                                    
                             
                                </div>
                                <div className="barcode-label barcode duplicate">
                                  <span style={{ textAlign: 'center', width: '100%', fontWeight: '900', color: '#000' }}>{item.Book_Classification_No}{" "}{item.authorMark}</span>
                  
                                  <Barcode
                                      width={2.5}
                                      height={36}
                                      margin={0}
                                      fontSize={18}
                                      value={item.Accession_No}
                                    />
                                    

                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                    <i className="p2 fa fa-print " aria-hidden="true" onClick={() => {
                        setSelectedIndex(index);

                        setTimeout(() => {
                          if (currentPrintRef.current) {
                            console.log(currentPrintRef);
                            reactSinglePrint();
                            
                           // handleBarCodePrint();
                          }
                        }, 100);
                                    }}></i>       
                         </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </section>
      {loaded && <BookCategoryCarosel />}
    </div>
  );
}
